import $ from "jquery";
import * as _utils from "@/assets/js/Utilities";
import { lutify, luts, UI } from '@/assets/js/Boot'
import { stripTimestamp, stripTimestampAndExtension } from "@/assets/js/Utilities";
import { systemLutsStore } from "@/services/indexedDB.service";

export default class CustomLUT {
    constructor() {
        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };

        this.colorSpaces = [
            {
                id: 0,
                name: 'ACEScct'
            },
            {
                id: 1,
                name: 'Rec709'
            },
            {
                id: 2,
                name: 'sRGB'
            },
            {
                id: 3,
                name: 'LogC3'
            },
            {
                id: 4,
                name: 'LogC4'
            },
            {
                id: 5,
                name: 'DaVinci Wide Gamut'
            },
            {
                id: 6,
                name: 'RED Wide Gamut'
            },
        ];
        this.colorSpacesLutNames = [
            'ACEScct-to-LogC3',
            'ACEScct-to-LogC4',
            'ACEScct-to-DWG',
            'DWG-to-ACEScct',
            'ACEScct-to-RWG',
        ]
    }

    async addBlock(blockNum = lutify.blocks.length, data) {
        UI.createAdjustmentBlockTemplate("custom-lut", blockNum, data);
        let $element = $(UI.getAdjustmentBlock(blockNum));

        UI.appendBlockLoadingSpinner($element);
        UI.scrollToBlock(lutify.activeBlock);
        UI.hideLUTtemplates();

        if (luts.loaded.customLUT.initialLoad) {
            let folders = await vm.$store.dispatch('UserFilesCustomLuts/index');
            await this.fetchCustomLutColourSpaceLuts();
            luts.loaded.customLUT.initialLoad = false;
        }

        $element.on("click", e => {
            const folderId = lutify.getActiveBlock().folder.id || lutify.getActiveBlock().selectedPreviewFolder;
            const folder = vm.$store.getters["UserFilesCustomLuts/folder"](folderId);

            this.refreshAllBlocks();

            if (folder.id) {
                this.showPreviews(folder);
            } else UI.hideLUTtemplates();
        });

        $element.find(".btn-reset-block").off("click").on("click", e => this.resetBlock($element, e));
        // $element.find(".btn-remove-lut-selection").on("click", e => {
        //     e.stopPropagation();
        //     this.removeLutSelection(lutify.getActiveBlock());
        // });
        $element.find(".opacity_slider").on("input", _ => this.opacitySliderHandler($element));
        $element.find(".opacity-input").on("change", _ => this.opacityInputHandler($element));

        $element.find(".color-space-selector__label-container").on("click", e => {
            e.stopPropagation();
            if ($(e.currentTarget).hasClass("--disabled")) return;
            this.toggleFolderDropdown(true);
            this.toggleCustomLutDropdown(true);
            this.toggleColorSpaceDropdown();
        });

        $element.find(".color-space-selector__items-container span").on("click", e => {
            e.stopPropagation();
            const colorSpace = this.colorSpaces.find(c => c.id == e.currentTarget.dataset.id);
            this.colorSpaceSelectionHandler(colorSpace);
        });

        $element.find(".control-selector__label-container").on("click", e => {
            e.stopPropagation();
            if ($(e.currentTarget).hasClass("--disabled")) return;
            this.toggleCustomLutDropdown(true);
            this.toggleColorSpaceDropdown(true);
            this.toggleFolderDropdown();
        });

        $element.find(".lut-selector__label-container").on("click", e => {
            e.stopPropagation();
            if ($(e.currentTarget).hasClass("--disabled")) return;
            $element.click();
            this.toggleFolderDropdown(true);
            this.toggleColorSpaceDropdown(true);
            this.toggleCustomLutDropdown();
        });

        $element.find(".btn-create-custom-luts-folder").on("click", _ => {
            UI.showModal(UI.modals.customLUT.createFolder.el);
        });

        $element.find(".btn-edit-custom-luts").on("click", e => {
            UI.showModal(UI.modals.customLUT.edit.el);
        });

        blocks.add({
            name: data.control,
            control: data.control,
            passes: await this.addPasses(),
            blockNum,
            blendingMode: 0,
            blendingModeName: "Normal",
            selectedPreviewFolder: null,
            opacity: 100,
            folder: {
                id: null,
                name: null
            },
            lut: {
                id: null,
                name: null
            },
            colorSpace: {
                id: 0,
                name: 'ACEScct'
            },

        });

        this.refreshAllBlocks();

        UI.removeBlockLoadingSpinner($element);

        $element.find(".expand_options").trigger("click", [false]);
        UI.attachTemporaryLUTSelectionHandler();
    }

    async fetchCustomLutColourSpaceLuts() {
        if (luts.customLutsBlockColourSpaceLuts.length > 0) return;

        const fetchedLuts = [];

        for await (const lutName of this.colorSpacesLutNames) {
            let lut = await systemLutsStore.getItem(lutName);

            if (!lut) {
                const response = await vm.$store.dispatch("Projects/fetchSystemLuts", {
                    type: "identity",
                    category: `${lutName}.cube`,
                });

                lut = await vm.$store.dispatch("Projects/fetchFile", response.presignedUrl);
                lut = new File([lut], response.fileName, { type: "text/plain" });

                await systemLutsStore.setItem(lutName, lut);
            }

            fetchedLuts.push(lut);
        }

        await luts.load(fetchedLuts, luts.customLutsBlockColourSpaceLuts);
    }

    async colorSpaceSelectionHandler(colorSpace) {
        this.toggleColorSpaceDropdown(true);

        lutify.getActiveBlock().colorSpace = colorSpace;

        let passIDT, passODT;

        if (colorSpace.id == 0) {
            passIDT = gpu.createRenderPass();
            passODT = gpu.createRenderPass();
        }

        if (colorSpace.id == 1) {
            const lutODTRec709 = luts.ODT.find(odt => odt.value == "ODT404");
            passIDT = gpu.createACESpass("ODT", lutODTRec709);

            const lutIDTRec709 = luts.get('Rec709-IDT-33', "IDTluts");
            passODT = gpu.createLUTPass(lutIDTRec709.texture);
        }

        if (colorSpace.id == 2) {
            const lutODTsRGB = luts.ODT.find(odt => odt.value == "ODT410");
            passIDT = gpu.createACESpass("ODT", lutODTsRGB);

            const lutIDTsRGB = luts.get('sRGB-IDT-33', "IDTluts");
            passODT = gpu.createLUTPass(lutIDTsRGB.texture);
        }

        if (colorSpace.id == 3) {
            passIDT = gpu.createLUTPass(luts.customLutsBlockColourSpaceLuts[0].texture)

            const lutIDTLogC3 = luts.IDT.find(idt => idt.value == "IDT107");
            passODT = gpu.createACESpass("IDT", lutIDTLogC3);
        }

        if (colorSpace.id == 4) {
            passIDT = gpu.createLUTPass(luts.customLutsBlockColourSpaceLuts[1].texture)

            const lutIDTLogC4 = luts.IDT.find(idt => idt.value == "IDT164");
            passODT = gpu.createACESpass("IDT", lutIDTLogC4);
        }

        if (colorSpace.id == 5) {
            passIDT = gpu.createLUTPass(luts.customLutsBlockColourSpaceLuts[2].texture)
            passODT = gpu.createLUTPass(luts.customLutsBlockColourSpaceLuts[3].texture)
        }

        if (colorSpace.id == 6) {
            passIDT = gpu.createLUTPass(luts.customLutsBlockColourSpaceLuts[4].texture)

            const lutIDTRWG = luts.IDT.find(idt => idt.value == "IDT110");
            passODT = gpu.createACESpass("IDT", lutIDTRWG);
        }

        if (colorSpace.id == 0) {
            passIDT.enabled = false;
            passODT.enabled = false;
        } else {
            passIDT.enabled = true;
            passODT.enabled = true;
        }

        passIDT.uid = lutify.getActiveBlock().passes[0].uid;
        passODT.uid = lutify.getActiveBlock().passes[2].uid;
        lutify.getActiveBlock().passes[0] = passIDT;
        lutify.getActiveBlock().passes[2] = passODT;
        const passIndexOfIDT = gpu.getPassIndexById(passIDT.uid);
        const passIndexOfODT = gpu.getPassIndexById(passODT.uid);
        gpu.composer.passes[passIndexOfIDT] = passIDT;
        gpu.composer.passes[passIndexOfODT] = passODT;

        let $block = UI.getActiveBlock();
        $block.find(".selected-color-space-name").html(colorSpace.name);

        gpu.render();
        lutPreviewer.render();

        const folder = vm.$store.getters["UserFilesCustomLuts/folder"](lutify.getActiveBlock().selectedPreviewFolder);
        this.showPreviews(folder);
    }

    refreshAllBlocks() {
        lutify.blocks.forEach(block => {
            if (block.control !== "customLUT") return;

            const $block = UI.getBlock(block.blockNum);
            if (!$block) return;

            let folder = vm.$store.getters["UserFilesCustomLuts/folder"](block.folder.id);

            if (block.folder.id && !folder.id) {
                block.folder = {
                    id: null,
                    name: null
                }
            }

            folder = vm.$store.getters["UserFilesCustomLuts/folder"](block.selectedPreviewFolder);
            if (block.selectedPreviewFolder && !folder.id) {
                block.selectedPreviewFolder = null;
            }

            const lut = vm.$store.getters["UserFilesCustomLuts/lut"](block.lut.id);

            if (block.lut.id && !lut.id) {
                this.showBlockWarn($block);
                this.removeLutSelection(block, false);

                block.lut = {
                    id: null,
                    name: null
                }
            }

            let lutName = null;
            if (block.lut.id) lutName = stripTimestampAndExtension(block.lut.name);

            this.refreshFoldersList($block, folder.name);
            this.refreshCustomLutsList($block, folder, lutName);
            this.refreshColorSpaceList($block, folder.id);
        })
    }

    refreshColorSpaceList($block = UI.getActiveBlock(), folderId) {
        $block
            .find(".color-space-selector__label-container")
            .addClass("--disabled");

        if (folderId) {
            $block
                .find(".color-space-selector__label-container")
                .removeClass("--disabled");
        }
    }

    refreshFoldersList($block = UI.getActiveBlock(), folderName) {
        $block
            .find(".block-sliders-container")
            .addClass("--disabled");

        if (folderName) {
            $block
                .find(".block-sliders-container")
                .removeClass("--disabled");
        }

        let items = this.getFoldersListElements();
        if (!folderName) folderName = "Select LUT folder";

        $block
            .find(".selected-control-name")
            .html(folderName);

        $block
            .find(`.control-selector__items-container > span`)
            .remove();

        if (items.length == 0) {
            $block
                .find(".control-selector__label-container")
                .addClass("--disabled");

            return;
        }

        $block
            .find(".control-selector__label-container")
            .removeClass("--disabled");
        $block
            .find(".control-selector__items-container")
            .append(items);
    }

    getFoldersListElements() {
        let items = [];
        vm.$store.state.UserFilesCustomLuts.customLuts.forEach(folder => {
            let item = document.createElement("span");
            item.setAttribute("data-folder", folder.id);
            item.innerHTML = folder.name;

            $(item).on("click", e => {
                e.stopPropagation();
                this.folderSelectionHandler(folder);
            });

            items.push(item);
        });
        return items;
    }

    async folderSelectionHandler(folder) {
        this.toggleFolderDropdown();

        let $block = UI.getActiveBlock();
        UI.appendBlockLoadingSpinner($block);
        lutify.getActiveBlock().selectedPreviewFolder = folder.id;

        // this.resetOpacity($block);
        // this.resetBlendingMode($block);
        this.refreshAllBlocks();

        if (!luts.customLUT[folder.id] || luts.customLUT[folder.id].length == 0) {
            UI.togglePreviewsContainer();
            UI.updatePreviewsTab(folder.name);
            lutPreviewer.showPlaceholderPreviews();
            await this.fetchCustomLutFiles(folder);
        }

        lutPreviewer.removePlaceholderPreviews();
        this.showPreviews(folder);
        this.removeLutSelection(lutify.getActiveBlock());

        UI.removeBlockLoadingSpinner($block);
    }

    refreshCustomLutsList($block = UI.getActiveBlock(), folder, lutName) {
        let items = [];
        if (!lutName) lutName = "None";

        if (folder) items = this.createCustomLutsListItemElementsList(folder);

        $block
            .find(".selected-lut-name")
            .html(lutName)

        $block
            .find(`.lut-selector__items-container > span`)
            .remove();

        if (items.length == 0) {
            $block
                .find(".lut-selector__label-container")
                .addClass("--disabled");

            return;
        }

        $block
            .find(".lut-selector__label-container")
            .removeClass("--disabled");
        $block
            .find(".lut-selector__items-container")
            .append(items);
    }

    createCustomLutsListItemElementsList(folder) {
        let items = [];
        folder.files.forEach(lut => {
            let item = document.createElement("span");
            item.setAttribute("data-file-id", lut.id);
            item.setAttribute("data-composer-index", luts.getComposerIndexById("customLUT", lut.id));

            item.innerHTML = stripTimestampAndExtension(lut.name);
            $(item).on("click", async e => {
                e.stopPropagation();
                await this.customLutSelectionHandler(folder, lut);
            });
            items.push(item);
        });
        return items;
    }

    async customLutSelectionHandler(folder, lut, triggerPreview = true) {
        this.toggleCustomLutDropdown();
        this.removeBlockWarn();
        this.removeBlockInfo();

        lutify.getActiveBlock().folder = {
            id: folder.id,
            name: folder.name
        };

        lutify.getActiveBlock().lut = {
            id: lut.id,
            name: lut.name
        };

        lutify.getActiveBlock().selectedPreviewFolder = folder.id;

        let $block = UI.getActiveBlock();
        this.refreshCustomLutsList($block, folder, stripTimestampAndExtension(lut.name));

        const composerIndex = luts.getComposerIndexById("customLUT", lut.id);

        const reader = new FileReader();
        reader.readAsBinaryString(luts.getFileById("customLUT", lut.id))
        await new Promise((resolve, reject) => {
            reader.onload = async event => {
                lutify.getActiveBlock().lutContent = reader.result;
                lutify.getActiveBlock().lutOwner = vm.$store.state.User.user.name;
                lutify.getActiveBlock().lutName = lut.name;
                lutify.getActiveBlock().lutId = lut.id;
                resolve();
            }
        })

        if (triggerPreview) $(`#previews-list-container > .list-item[data-composer-index="${composerIndex}"]`).trigger("click");
    }

    async fetchCustomLutFiles(folder) {
        const luts = await vm.$store.dispatch('UserFilesCustomLuts/fetch', folder);
        await this.createLUTobjects(luts, folder.id);
        this.refreshAllBlocks();
    }

    async createLUTobjects(lutList, folderId) {
        if (!luts.customLUT[folderId]) luts.customLUT[folderId] = [];

        lutList = lutList.filter(lut => {
            if (luts.customLUT[folderId].find(lutObject => lutObject.lutId == lut.id)) return false;
            else return lut;
        })

        let lutObjects = await luts.load(lutList.map(lut => lut.file), luts.customLUT[folderId]);

        lutObjects.forEach((lut, i) => {
            lut.file = lutList[i].file;
            lut.control = "customLUT";
            lut.category = folderId;
            lut.lutId = lutList[i].id;
            lut.folderId = lutList[i].folderId;
            lut.title = stripTimestampAndExtension(lutList[i].name);
        });

        lutPreviewer.createPreviews(lutObjects, "canRemove");
        lutPreviewer.sortPreviews(
            folderId,
            luts.customLUT[folderId].map(item => item.title)
        );
    }

    toggleColorSpaceDropdown(forceHide = false) {
        const $block = UI.getActiveBlock();
        let itemsContainer = $block.find(".color-space-selector__items-container");

        if (forceHide) {
            itemsContainer.hide();
            return;
        }

        if (itemsContainer.is(":visible")) itemsContainer.hide();
        else itemsContainer.show();
    }

    toggleFolderDropdown(forceHide = false) {
        const $block = UI.getActiveBlock();
        let itemsContainer = $block.find(".control-selector__items-container");

        if (forceHide) {
            itemsContainer.hide();
            return;
        }

        if (itemsContainer.is(":visible")) itemsContainer.hide();
        else itemsContainer.show();
    }

    toggleCustomLutDropdown(forceHide = false) {
        const $block = UI.getActiveBlock();
        let itemsContainer = $block.find(".lut-selector__items-container");

        if (forceHide) {
            itemsContainer.hide();
            return;
        }

        if (itemsContainer.is(":visible")) itemsContainer.hide();
        else itemsContainer.show();
    }

    async addPasses() {
        const renderPass1 = gpu.createRenderPass();
        gpu.addPassToComposer(renderPass1, "toMiddle");

        const renderPass2 = gpu.createRenderPass();
        gpu.addPassToComposer(renderPass2, "toMiddle");

        const renderPass3 = gpu.createRenderPass();
        gpu.addPassToComposer(renderPass3, "toMiddle");

        return [renderPass1, renderPass2, renderPass3];
    }

    showPreviews(folder) {
        if (!folder.id) return;

        UI.togglePreviewsContainer();
        UI.updatePreviewsTab(folder.name);
        lutPreviewer.switchCanvases(folder.id, "customLUT");

        const composerIndex = luts.getComposerIndexById("customLUT", lutify.getActiveBlock().lut.id)
        if (lutify.getActiveBlock().lut.id) UI.updateSelectedPreview(composerIndex);

        lutPreviewer.cloneMainComposerPasses();
        lutPreviewer.addPass(lutify.getActiveBlock().control, folder.id, 1, lutify.getActiveBlock().blendingMode);
        lutPreviewer.render();
        setTimeout(() => {
            lutPreviewer.render();
        }, 10)
    }

    opacitySliderHandler($element) {
        let opacityValue = $element.find(".opacity_slider").val();
        let calcOpacityValue = opacityValue * 0.01;

        $element.find(".opacity-input").val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes[1].uniforms.opacity.value = calcOpacityValue;

        lutPreviewer.updateOpacity(calcOpacityValue);
        UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);

        gpu.render();
        lutPreviewer.render();
    }

    opacityInputHandler($element) {
        let opacityValue = $element.find(".opacity-input").val();
        let opacitySlider = $element.find(".opacity_slider");

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger("input");
    }

    showBlockWarn($block = UI.getActiveBlock()) {
        this.removeBlockWarn($block);

        let htmlWarn = '<i class="material-icons block-warn" data-tippy-content="LUT is missing">error_outline</i>';
        $block.find(".header-container .controls-wrapper").prepend(htmlWarn);
    }

    showBlockInfo($block = UI.getActiveBlock()) {
        this.removeBlockInfo($block);

        const htmlWarn = '<i class="material-icons block-info" data-tippy-content="This block uses a custom LUT not from your library or the LUT might have been deleted.">error_outline</i>';
        $block.find(".header-container .controls-wrapper").prepend(htmlWarn);

        const lutName = stripTimestampAndExtension(lutify.getActiveBlock().lutName);
        const lutOwner = lutify.getActiveBlock().lutOwner;
        const htmlMessage = `
            <div class="block-message">
                <div class="d-flex justify-space-between align-center mb-2" style="line-height: 1.2">
                    <span>Custom LUT</span>
                    <span class=" d-block">${lutName}</span>
                </div>
                <div class="d-flex justify-space-between align-center mb-6" style="line-height: 1.2">
                    <span>Owned by</span>
                    <span class=" d-block">${lutOwner}</span>
                </div>
                <span class="d-block mb-2" style="line-height: 1.2">You cannot edit deleted LUTs or LUTs owned by another user.</span>
            </div>
        `;

        $block.find('.block_options').append(htmlMessage);

        // $block.find(".block_options .custom-lut-buttons-container").removeClass('d-flex');
        $block.find(".block_options .block-option").removeClass('d-flex');

        // $block.find(".block_options .custom-lut-buttons-container").addClass('d-none');
        $block.find(".block_options .block-option").addClass('d-none');
        $block.find(".block_options .block-sliders-container ").addClass('d-none');
    }

    removeBlockWarn($block = UI.getActiveBlock()) {
        $block.find(".header-container .block-warn").remove();
    }

    removeBlockInfo($block = UI.getActiveBlock()) {
        $block.find(".header-container .block-info").remove();
        $block.find(".block_options .block-message").remove();

        // $block.find(".block_options .custom-lut-buttons-container").addClass('d-flex');
        $block.find(".block_options .block-option").addClass('d-flex');

        // $block.find(".block_options .custom-lut-buttons-container").removeClass('d-none');
        $block.find(".block_options .block-option").removeClass('d-none');
        $block.find(".block_options block-sliders-container ").removeClass('d-none');
    }

    resetOpacity($block) {
        $block.find(".opacity-input").val(100);
        $block.find(".opacity-input").trigger("change");
    }

    resetBlendingMode($block) {
        $block.find('.blending-mode__items-container > span[data-id="0"]').trigger("click");
    }

    async resetBlock($block, e) {
        e.stopPropagation();
        this.resetOpacity($block);
        this.resetBlendingMode($block);

        UI.scrollToSelectedPreview();

        lutify.getActiveBlock().folder = {
            id: null,
            name: null
        }

        lutify.getActiveBlock().selectedPreviewFolder = null;
        this.removeLutSelection(lutify.getActiveBlock());
        UI.hideLUTtemplates();

        const renderPass = gpu.createRenderPass();
        renderPass.uid = lutify.getActiveBlock().passes[1].uid;
        const passIndex = gpu.getPassIndexById(lutify.getActiveBlock().passes[1].uid);
        lutify.getActiveBlock().passes[1] = renderPass;
        gpu.composer.passes[passIndex] = lutify.getActiveBlock().passes[1];

        const colorSpace = this.colorSpaces.find(c => c.id == 0);
        await this.colorSpaceSelectionHandler(colorSpace);

        gpu.render();
        lutPreviewer.render();
    }

    removeLutSelection(block, refresh = true) {
        block.lut = {
            id: null,
            name: null
        }

        UI.deselectPreview();
        if (refresh) this.refreshAllBlocks();
        block.passes[1].enabled = false;
        gpu.render();
    }

    async applyCompare($block, data) {
        if (!data.lut.id && !data.lutContent) return;

        let folder = vm.$store.getters["UserFilesCustomLuts/folder"](data.folder.id);
        let lut = vm.$store.getters["UserFilesCustomLuts/lut"](data.lut.id);

        if (!lut.id) {
            lut = vm.$store.getters["UserFilesCustomLuts/lut"](data.lutId);
            if (lut.id) {
                folder = vm.$store.getters["UserFilesCustomLuts/folderByLutId"](data.lutId);
            }
        }

        window.lutify.getActiveBlock().collapsedPreviews = data.collapsedPreviews;

        if (lut.id) {
            if (folder.id) {
                await this.folderSelectionHandler(folder);
                this.toggleFolderDropdown(true);
            }

            await this.customLutSelectionHandler(folder, lut);
            this.toggleCustomLutDropdown(true);

            const colorSpace = this.colorSpaces.find(c => c.id == data.colorSpace.id);
            await this.colorSpaceSelectionHandler(colorSpace);

            $block.find(".opacity-input").val(parseInt(data.opacity));
            $block.find(".opacity-input").trigger("change");

            if (data.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${data.blendingMode}"]`).trigger("click");
        } else if (data.lutContent) {
            const file = new File([data.lutContent], data.lut.name);
            const lutObjects = await luts.load([file]);
            const pass = gpu.createLUTPass(lutObjects[0].texture);
            pass.uid = lutify.getActiveBlock().passes[1].uid;
            pass.uniforms.opacity.value = parseInt(data.opacity) / 100;

            lutify.getActiveBlock().passes[1] = pass;
            let passIndex = gpu.getPassIndexById(pass.uid);
            gpu.composer.passes[passIndex] = pass;

            if (data.active == 0) $block.find(".controls-wrapper .switch > input").trigger("click");

            gpu.render();
            lutPreviewer.render();

            lutify.getActiveBlock().lutContent = data.lutContent;
            lutify.getActiveBlock().lutOwner = data.lutOwner;
            lutify.getActiveBlock().lutName = data.lutName;
            lutify.getActiveBlock().lutId = data.lutId;
            this.showBlockInfo();

            const colorSpace = this.colorSpaces.find(c => c.id == data.colorSpace.id);
            await this.colorSpaceSelectionHandler(colorSpace);

            if (data.blendingMode !== 0) $block.find(`.blending-mode__items-container > span[data-id="${data.blendingMode}"]`).trigger("click");
        } else {
            this.showBlockInfo();
        }
    }
}
